import React, { useEffect } from 'react'

import { ReviewButtons } from './ReviewButtons/ReviewButtons'
import { ReviewDisplay } from './ReviewDisplay/ReviewDisplay'

import { useAppDispatch, useAppSelector } from 'common/hooks'
import { saveState } from 'common/utils'
import { selectActivityData, selectNextTaskId, setResult } from 'features/dashboard'
import { selectCurrentTask } from 'features/simulator'

export const Review = () => {
  const dispatch = useAppDispatch()
  const task = useAppSelector(selectCurrentTask)!
  const symbolsPerMinute = useAppSelector(state => state.simulator.results.symbolsPerMinute)!
  const nextTaskId = useAppSelector(state => selectNextTaskId(state, task.categoryId, task.id))
  const activityData = useAppSelector(selectActivityData)

  useEffect(() => {
    if (symbolsPerMinute) {
      dispatch(
        setResult({ categoryId: task.categoryId, taskId: task.id, result: symbolsPerMinute })
      )
    }
  }, [])

  // save data to localStorage
  useEffect(() => {
    saveState('activity', activityData)
  }, [activityData])

  return (
    <div>
      <ReviewDisplay nextTaskId={nextTaskId} />
      <ReviewButtons nextTaskId={nextTaskId} />
    </div>
  )
}
